import React, { Component } from 'react'
import { Field } from 'formik'
import { map } from 'lodash'
import { FormikSelect, FormikInput, Row, Column, Divider, Button } from '../../common'
import { getUserStatus } from '../../../utils/misc'

const userStatus = map(getUserStatus(), ({ key, value }) => ({ value: key, label: value }))

const salesChannels = [
  { value: 1, label: 'Jumbo Los Andes' },
  { value: 23, label: 'Jumbo Peñalolén' },
  { value: 36, label: 'Jumbo La Reina' },
  { value: 35, label: 'Jumbo Maipú' },
  { value: 34, label: 'Jumbo La Dehesa' },
  { value: 33, label: 'Jumbo Los Domínicos' },
  { value: 32, label: 'Jumbo Concha y Toro' },
  { value: 31, label: 'Jumbo Kennedy' },
  { value: 16, label: 'Jumbo Viña del Mar' },
  { value: 28, label: 'Jumbo Ñuñoa' },
  { value: 27, label: 'Jumbo Bilbao' },
  { value: 22, label: 'Jumbo El Llano' }
]

const profiles = [
  { value: 1, label: 'PickerJr' },
  { value: 2, label: 'PickerSenior' },
  { value: 3, label: 'Supervisor' },
  { value: 4, label: 'Administrador' },
  { value: 5, label: 'Gestor' }
]

const EditUserForm = ({ onClose, form }) => {
  const { setFieldValue, handleReset, handleSubmit, isSubmitting } = form
  return (
    <form onSubmit={handleSubmit} onReset={handleReset}>
      <Column>
        <Row >
          <Field component={FormikInput} label='Nombre' name='firstName' />
          <Field component={FormikInput} label='Apellido' name='lastName' />
          <Field component={FormikInput} label='RUT' name='document' />
          <Field component={FormikInput} label='Telefono' name='phone' />
          {/* <Field component={FormikSelect} name='salesChannel' label='Sala' options={salesChannels} setFieldValue={setFieldValue} getDefaultSelected={(field) => get(field, 'value.id')} /> */}
          <Field component={FormikSelect} name='role' label='Rol' options={profiles} setFieldValue={setFieldValue} />
          <Field component={FormikSelect} name='status' label='Estado' options={userStatus} setFieldValue={setFieldValue} />
        </Row>

        <Divider bottom={12} top={23} />
        <Row style={{ flexFlow: 'row' }}>
          <Button link text='Cancelar' type='reset' disabled={isSubmitting} loading={isSubmitting} />
          <Button type='submit' text='Guardar' disabled={isSubmitting} />
        </Row>
      </Column>
    </form>
  )
}

export default EditUserForm
